import { createSlice } from "@reduxjs/toolkit";
import {
  getSingleTrackingAction,
  getBulkTrackingAction,
} from "../../actions/PostalTracking/postalTrackingAction";

const initialState = {
  singleData: null,
  bulkData: [],
  singleLoading: false,
  bulkLoading: false,
  singleError: null,
  bulkError: null,
};

const postalTrackingSlice = createSlice({
  name: "postalTracking",
  initialState,
  reducers: {
    resetTracking: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSingleTrackingAction.pending, (state) => {
        state.singleLoading = true;
        state.singleError = null;
      })
      .addCase(getSingleTrackingAction.fulfilled, (state, action) => {
        state.singleLoading = false;
        state.singleData = action.payload;
      })
      .addCase(getSingleTrackingAction.rejected, (state, action) => {
        state.singleLoading = false;
        state.singleError = action.payload;
      })
      .addCase(getBulkTrackingAction.pending, (state) => {
        state.bulkLoading = true;
        state.bulkError = null;
      })
      .addCase(getBulkTrackingAction.fulfilled, (state, action) => {
        state.bulkLoading = false;
        state.bulkData = Array.isArray(action.payload)
          ? action.payload
          : action.payload
            ? [action.payload]
            : [];
      })
      .addCase(getBulkTrackingAction.rejected, (state, action) => {
        state.bulkLoading = false;
        state.bulkError = action.payload;
      });
  },
});

export const { resetTracking } = postalTrackingSlice.actions;
export default postalTrackingSlice.reducer;
